import * as React from "react";
const Svg16PxEss = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", "data-name": "Layer 1", viewBox: "0 0 16 16", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M11.59 10.45 8.86 2H7.15l-2.73 8.45H3.01V13h10v-2.55zM9.31 6.21H6.7l.23-.72h2.14zm.29.86.58 1.81H5.84l.57-1.81zM8.24 2.86l.57 1.77h-1.6l.57-1.77zM5.57 9.72h4.89l.23.72H5.33zm6.57 2.42H3.87v-.84h8.27z", style: {
  fill: "currentColor"
} }));
export default Svg16PxEss;
